import { createContext, useContext, useMemo } from 'react';
import { UsageTracker } from 'asset-actions-lib/utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackerContext = /*#__PURE__*/createContext(undefined);
export default function TrackerProvider({
  applicationId,
  children,
  objectTypeId,
  objectId,
  onTrackEvent
}) {
  const value = useMemo(() => ({
    applicationId,
    objectTypeId,
    objectId,
    onTrackEvent,
    tracker: UsageTracker
  }), [applicationId, objectTypeId, objectId, onTrackEvent]);
  return /*#__PURE__*/_jsx(TrackerContext.Provider, {
    value: value,
    children: children
  });
}
export function useTracker() {
  const context = useContext(TrackerContext);
  if (context === undefined) {
    throw new Error('useTracker must be used within a TrackerProvider');
  }
  return context;
}